
import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showHome?: boolean;
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ 
  items, 
  showHome = true, 
  className = "" 
}) => {
  const breadcrumbItems = showHome 
    ? [{ label: "Accueil", href: "/" }, ...items]
    : items;

  // Generate structured data for breadcrumbs
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.label,
      ...(item.href && { "item": `https://www.groupefabre-environnement.fr${item.href}` })
    }))
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      <nav 
        aria-label="Fil d'Ariane" 
        className={`bg-gray-50 py-3 ${className}`}
        role="navigation"
      >
        <div className="container mx-auto px-4">
          <ol className="flex items-center space-x-2 text-sm text-gray-600">
            {breadcrumbItems.map((item, index) => (
              <li key={index} className="flex items-center">
                {index > 0 && (
                  <ChevronRight className="w-4 h-4 mx-2 text-gray-400" aria-hidden="true" />
                )}
                
                {item.current || !item.href ? (
                  <span 
                    className="text-fabre-gray font-medium" 
                    aria-current="page"
                  >
                    {index === 0 && showHome ? (
                      <span className="flex items-center">
                        <Home className="w-4 h-4 mr-1" aria-hidden="true" />
                        {item.label}
                      </span>
                    ) : (
                      item.label
                    )}
                  </span>
                ) : (
                  <Link 
                    to={item.href} 
                    className="text-fabre-green hover:text-fabre-darkgreen transition-colors duration-200"
                    aria-label={`Aller à ${item.label}`}
                  >
                    {index === 0 && showHome ? (
                      <span className="flex items-center">
                        <Home className="w-4 h-4 mr-1" aria-hidden="true" />
                        {item.label}
                      </span>
                    ) : (
                      item.label
                    )}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
};

export default Breadcrumb;
